// app/costiBase/costiBase.js

(function () {
    'use strict';
    var controllerId = 'costiBase';
    angular.module('app').controller(controllerId, ['$rootScope', '$routeParams', '$filter', 'common', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', '$translate', costiBaseFn]);

    function costiBaseFn($rootScope, $routeParams, $filter, common, bDialog, $uibModal, datacontext, sectionMenu, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = $translate.instant('CostiBase');
        vm.sectionMenu = sectionMenu.setSection('CostiBase');
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        //vm.sectionMenu = sectionMenu.setSection(vm.title);                
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        //data
        vm.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened = !vm.opened;
        };        

        vm.clear = function ($event) {
            vm.fData = '';
            vm.changed = true;
        };
        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';        
                
        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Titolo', 'Tipo'];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };        
        
        //Filtro
        vm.filter = {};        
        vm.filter.ricerca = vm.fRicerca = '';
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;              
        vm.getRecord = getRecord;        
        vm.get = getRecord;        

        //Gestione CostiBase       
        vm.add = addCostiBase;
        vm.update = updateItem;
        vm.edit = edit;
        vm.delete = deleteCostiBase;           

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                .then(function () {                    
                    //if ($routeParams.TeamId != null) {
                    //    setView('detail');
                    //    getRecord($routeParams.TeamId, 0);
                    //}
                });
        }

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            //console.info('data', vm.record);
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;            
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.costiBase_countAll(vm.filter.ricerca).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.costiBase_getAll(vm.pageSize, vm.page, vm.filter.ricerca, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    vm.records.push.apply(vm.records, data);                   
                }
                vm.loading = false;                   
            });            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {            
            return datacontext.costiBase_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;                
                
                //Azzera liste                
                if (vm.record.DataFine != null) vm.record.DataFine = new Date(vm.record.DataFine);
                setView('detail');
            });
        }               

        //Gestione CostiBase
        // implementazione del metodo addCostiBase (definito sopra) che si scatena quando clicco sul bottone "Aggiungi" 
        function addCostiBase() {
            var modalCostiBase = {};
            modalCostiBase.Id = 0;   // devo aggiungere un nuovo record e sappiamo che ogni nuovo record è identificato da un Id pari a 0
           
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/costiBase/modal/costiBaseAdd.html?version=30',   
                controller: 'costiBaseAdd',
                resolve: {                                          // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    costiBase: function () {                            // in questo caso passiamo un solo oggetto che si chiama 'costiBase' che ha come valore modalCostiBase
                        return modalCostiBase;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {               // eseguito a seguito della chiusura della modale
                if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));   // analizza l'oggetto tornato 'returnItem' = 'costiBaseAdd.result'
                //  (può essere nullo se l'aggiornamento non va a buon fine)
                
                logSuccess($translate.instant('Costo base aggiunto con successo'));
                //vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione
                //addRecord(returnItem.Id);
                cerca();
            });
        }

        function updateItem() {            
            return datacontext.costiBase_update(vm.record).then(function (data) {
                if (data) {
                    vm.records[vm.index] = data;
                    logSuccess($translate.instant('Dati salvati'));
                }
                else
                    logError($translate.instant('Impossibile salvare i dati'));
            });
        }

        //non viene utilizzata la modale perchè utilizzo il detail
        function edit(item) {
            var modalCostiBase = {};
            angular.copy(item, modalCostiBase);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/costiBase/modal/costiBaseAdd.html?version=30',   
                controller: 'costiBaseAdd',
                resolve: {                                          // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    costiBase: function () {                            // in questo caso passiamo un solo oggetto che si chiama 'costo' che ha come valore modalCostiBase
                        return modalCostiBase;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {               // eseguito a seguito della chiusura della modale
                if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));   // analizza l'oggetto tornato 'returnItem' = 'costiBaseAdd.result'
                //  (può essere nullo se l'aggiornamento non va a buon fine)

                logSuccess($translate.instant('Costo base modificato con successo'));
                vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione               
                //cerca();
            });
        }

        function deleteCostiBase(item) {
            var msg = " " + $translate.instant('il costo base') + " " + item.Titolo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.costiBase_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));
                    logSuccess($translate.instant('Costo base eliminato con successo'));
                    //vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione
                    //var index = vm.records.indexOf(item)
                    //vm.records.splice(index, 1);
                    //vm.countRecords--;
                    cerca();
                });              
            });
        }       
    }
})();
